/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  UserIconComponent,
  UserProfileComponent,
  UserProfileNameComponent,
  UserProfileSharedModule,
} from '@alfa-client/user-profile-shared';
import { ZustaendigeStelleModule } from '@alfa-client/zustaendige-stelle';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { HasLinkPipe } from '@common/tech-shared';
import { ButtonWithSpinnerComponent, InstantSearchEditorComponent } from '@odc/component';
import {
  DropdownMenuButtonItemComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  DropdownMenuLinkItemComponent,
  IconComponent,
  SearchResultItemComponent,
  TooltipDirective,
} from '@ods/system';
import { SpinnerComponent } from '@ui';
import { AssignUserProfileButtonContainerComponent } from './assign-user-profile-button-container/assign-user-profile-button-container.component';
import { userProfileHistorieProviders } from './historie/user-profile-historie.providers';
import { LinkWithUserNameTooltipContainerComponent } from './link-with-user-name-tooltip-container/link-with-user-name-tooltip-container.component';
import { LinkWithUserNameTooltipComponent } from './link-with-user-name-tooltip-container/link-with-user-name-tooltip/link-with-user-name-tooltip.component';
import { TextWithUserNameTooltipContainerComponent } from './text-with-user-name-tooltip-container/text-with-user-name-tooltip-container.component';
import { TextWithUserNameTooltipComponent } from './text-with-user-name-tooltip-container/text-with-user-name-tooltip/text-with-user-name-tooltip.component';
import { UserProfileDropdownContainerComponent } from './user-profile-dropdown-container/user-profile-dropdown-container.component';
import { UserProfileSearchContainerComponent } from './user-profile-dropdown-container/user-profile-dropdown-content/user-profile-search-container/user-profile-search-container.component';
import { UserProfileSearchResultsContainerComponent } from './user-profile-dropdown-container/user-profile-dropdown-content/user-profile-search-container/user-profile-search/user-profile-search-results-container/user-profile-search-results-container.component';
import { UserProfileSearchResultsComponent } from './user-profile-dropdown-container/user-profile-dropdown-content/user-profile-search-container/user-profile-search/user-profile-search-results-container/user-profile-search-results/user-profile-search-results.component';
import { UserProfileSearchComponent } from './user-profile-dropdown-container/user-profile-dropdown-content/user-profile-search-container/user-profile-search/user-profile-search.component';
import { UserProfileVorgangUserComponent } from './user-profile-dropdown-container/user-profile-dropdown-content/user-profile-vorgang-user/user-profile-vorgang-user.component';
import { UserProfileInHeaderContainerComponent } from './user-profile-in-header-container/user-profile-in-header-container.component';
import { UserProfileInHeaderComponent } from './user-profile-in-header-container/user-profile-in-header/user-profile-in-header.component';
import { UserProfileInKommentarContainerComponent } from './user-profile-in-kommentar-container/user-profile-in-kommentar-container.component';
import { UserProfileInPostfachMailContainerComponent } from './user-profile-in-postfach-mail-container/user-profile-in-postfach-mail-container.component';
import { UserProfileInVorgangContainerComponent } from './user-profile-in-vorgang-container/user-profile-in-vorgang-container.component';
import { UserProfileInVorgangComponent } from './user-profile-in-vorgang-container/user-profile-in-vorgang/user-profile-in-vorgang.component';
import { UserProfileUnassignedComponent } from './user-profile-unassign/user-profile-unassigned.component';

@NgModule({
  imports: [
    CommonModule,
    UserProfileSharedModule,
    RouterModule,
    HasLinkPipe,
    SpinnerComponent,
    MatMenuTrigger,
    ReactiveFormsModule,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    DropdownMenuButtonItemComponent,
    DropdownMenuLinkItemComponent,
    ButtonWithSpinnerComponent,
    IconComponent,
    SearchResultItemComponent,
    TooltipDirective,
    InstantSearchEditorComponent,
    ZustaendigeStelleModule,
    UserIconComponent,
    UserProfileComponent,
    UserProfileNameComponent,
  ],
  declarations: [
    UserProfileInVorgangContainerComponent,
    UserProfileSearchContainerComponent,
    AssignUserProfileButtonContainerComponent,
    UserProfileInKommentarContainerComponent,
    UserProfileDropdownContainerComponent,
    UserProfileInPostfachMailContainerComponent,
    UserProfileInVorgangComponent,
    LinkWithUserNameTooltipContainerComponent,
    LinkWithUserNameTooltipComponent,
    TextWithUserNameTooltipContainerComponent,
    TextWithUserNameTooltipComponent,
    UserProfileInHeaderContainerComponent,
    UserProfileInHeaderComponent,
    UserProfileSearchComponent,
    UserProfileUnassignedComponent,
    UserProfileVorgangUserComponent,
    UserProfileSearchResultsComponent,
    UserProfileSearchResultsContainerComponent,
  ],
  exports: [
    UserProfileInVorgangContainerComponent,
    UserIconComponent,
    AssignUserProfileButtonContainerComponent,
    UserProfileInKommentarContainerComponent,
    UserProfileInPostfachMailContainerComponent,
    LinkWithUserNameTooltipContainerComponent,
    TextWithUserNameTooltipContainerComponent,
    UserProfileInHeaderContainerComponent,
    UserProfileComponent,
  ],
  providers: [...userProfileHistorieProviders],
})
export class UserProfileModule {}
